/**
 * NOTE: This code belongs to Kangaroo Rewards. Unauthorized use is prohibited
 */

@file:Suppress("unused", "MemberVisibilityCanBePrivate", "EXPERIMENTAL_API_USAGE")
@file:OptIn(ExperimentalJsExport::class)
package features.userCoupons

import kangaroorewards.appsdk.core.api.Api
import kangaroorewards.appsdk.core.domain.Result
import kangaroorewards.appsdk.core.domain.Result.Idle
import kangaroorewards.appsdk.core.domain.Result.Loading
import kangaroorewards.appsdk.core.domain.SerializedResult
import kangaroorewards.appsdk.core.domain.toJsonResult
import kangaroorewards.appsdk.core.utils.CFlow
import kangaroorewards.appsdk.core.utils.asCFlow
import kotlinx.coroutines.ExperimentalCoroutinesApi
import kotlinx.coroutines.flow.MutableStateFlow
import kotlinx.coroutines.flow.mapLatest
import kotlinx.serialization.InternalSerializationApi
import kotlin.js.ExperimentalJsExport
import features.userCoupons.internal.UserCouponsUseCase
import features.userCoupons.internal.UserCouponsUseCase.Params
import features.userCoupons.models.UserCouponsModel


typealias UserCouponsState = CFlow<UserCouponsUseCaseResult?>

typealias UserCouponsUseCaseResult = Result<UserCouponsModel>

fun UserCouponsUseCaseResult.serializeUserCouponsApiResult(): SerializedResult<String> {
    return this.toJsonResult<UserCouponsModel>()
}

/**
 * Serializes [UserCouponsState]'s data and returns a new
 * [CFlow] containing data serialized as a JSON [String].
 */
@OptIn(ExperimentalCoroutinesApi::class)
fun UserCouponsState.serializeUserCouponsState(): CFlow<SerializedResult<String>?> {
    return this.mapLatest {
        it?.toJsonResult<UserCouponsModel>()
    }.asCFlow()
}

/**
 * Get a list of available coupons for this user. [Api] class
 */
class UserCouponsApi : Api() {

    val userCouponsState: UserCouponsState
        get() = _userCouponsState.asCFlow()

    companion object {
        private val _userCouponsState: MutableStateFlow<UserCouponsUseCaseResult> = MutableStateFlow(Idle())
    }

    private val userCouponsUseCase = UserCouponsUseCase()

    /**
     * Get a list of available coupons for this user.
     */
    suspend fun getUserCoupons(
        overrideHeaders: Map<String, String>? = null,

    ): Result<UserCouponsModel> {
        /* set state to Loading as soon as function is called */
        _userCouponsState.value = Loading()
        val result = this.userCouponsUseCase(
            Params(
                overrideHeaders = overrideHeaders,

            )
        
        ) { result ->
            _userCouponsState.value = result
            return@userCouponsUseCase result
        }
        return result
    }

}
